import React from 'react';

export const ChallengeContext = React.createContext<React.MutableRefObject<Promise<string> | null>>({ current: null });
